import Container from "@components/ui/container.tsx";
import { JobAlertsPanel, type JobAlertsPanelProps } from "@components/job_alerts/panel.tsx";

const JobAlerts = (props: JobAlertsPanelProps) => (
  <Container className="!max-w-[1550px]">
    <JobAlertsPanel {...props} variant="page" />
  </Container>
);

export default JobAlerts;
